/*
 eslint-disable eqeqeq,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
*/
import $ from 'jquery';
import moment from 'moment';
import fetch from 'cross-fetch';
import { formatDatetime } from './utils/formatting';
import { markdown } from './utils/markdown';

interface IncidentRecord {
    id: string;
    message: string;
    updated_at: string;
    name: string;
}

interface IncidentResponse {
    data: IncidentRecord[];
}

function maintenanceModule(): void {
    function writeCookie(name: string, value: string, days?: number): void {
        let date: Date | undefined;
        let expires: string;
        if (days) {
            date = new Date();
            date.setDate(date.getDate() + days);
            expires = `; expires=${date.toUTCString()}`;
        } else {
            expires = '';
        }
        document.cookie = `${name}=${value}${expires}; path=/`;
    }

    function readCookie(name: string): string {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return '';
    }

    if (document.URL.includes('localhost')) {
        // No need in doing this on development.
        return;
    }

    // TODO(#2865): upgrade Cachet to 2.4 so it returns usable CORS headers.
    // Until then we rely on `mode: 'no-cors'` which yields an opaque body, especially on dev hosts.
    void fetch('https://status.omnidots.com/api/v1/incidents?per_page=1&order=asc&sort=id', {
        mode: 'no-cors',
    })
        .catch(() => null)
        .then((response) => {
            if (!response || !response.ok || response.type === 'opaque') {
                // status.omnidots.com only permits requests coming from omnidots.com
                // so on dev hosts we cannot read the response body.
                // Returning null prevents `.json()` from throwing.
                return null;
            }
            return response.json() as Promise<IncidentResponse>;
        })
        .then((lastIncident) => {
            const [incident] = lastIncident?.data ?? [];
            if (!incident) {
                return;
            }

            const messageHtml = markdown(incident.message);

            // User has read it already.
            if (readCookie(`status_hidden_${incident.id}`) != '') return;

            const incidentTime = moment(incident.updated_at);
            const now = moment();

            // Check if it's about something that happened today or something in the future
            // Otherwise there is no reason to show it.
            if (!incidentTime.isSame(now, 'day') && incidentTime.isBefore(now)) return;

            $('.status-check .status-title').text(incident.name);
            $('.status-check .status-message').html(messageHtml);
            $('.status-check .status-timestamp').text(formatDatetime(incident.updated_at));
            $('.status-check').removeClass('hidden');

            // Show/hide the details.
            $('.status-check').on('click', function click(this: HTMLElement) {
                $(this).toggleClass('collapsed');
            });

            // Allow the user to hide notifications about this number.
            $('.status-check .delete').click(() => {
                $('.status-check').hide();
                writeCookie(`status_hidden_${incident.id}`, '1');
            });
        });
}

export default maintenanceModule;
